/* eslint-disable */
import { isOAuthCallbackRoute } from 'helpers/authCallback';
import env from 'helpers/env';

let segmentInitializationStarted = false;

// global window
// Radium reads the Node global name while rendering, including on /oauth/*.
window.global = window;

export const initializeThirdPartyScripts = () => {
  if (window !== window.parent) {
    return;
  }

  // Hubspot Tracker code
  window._hsq = window._hsq = window._hsq || [];
  // Beamer config
  window.beamer_config = {
    product_id: env.beamerProductId,
    selector: '.beamerTrigger',
    lazy: true
  };

  // Segment init is skipped only on the transient OAuth screen. Welcome may
  // call this function after SPA navigation to initialize it on that route.
  if (
    !isOAuthCallbackRoute() &&
    !window.analytics &&
    !segmentInitializationStarted &&
    typeof window.initSegment === 'function'
  ) {
    segmentInitializationStarted = true;
    try {
      window.initSegment(env.segmentWriteKey);
    } catch (error) {
      segmentInitializationStarted = false;
      throw error;
    }
  }
};

// Keep the optimized OAuth initial load free of third-party SDK bootstrap.
if (!isOAuthCallbackRoute()) {
  initializeThirdPartyScripts();
}
